import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import lang from '@/lang'
import { querySOPConfig } from '@/api/sysManage/baseConfig/warnRuleConfiguration'
import * as WarnRuleConstants from '@/class/cargo/model/parameters/WarnRuleConstants'
import LocalStorageUtils from '@/utils/localStorageUtils'
import {
  getAEJobSopInfo,
  getAIJobSopInfo, getIEJobSopInfo, getREJobSopInfo,
  getSEJobSopInfo,
  getSIJobSopInfo
} from '@/api/booking/job'
import { getTrackingBySopTemplateKeys, getTrackingInfoByLob } from '@/api/seaExport/seaExportJob'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import ZH from '@/lang/zh'
import $store from '@/store'
import ColumnUtils from '@/utils/ColumnUtils'
import { getListByTemplateKey } from '@/api/trackingService'

/**
 * 第三方平台通道数据缓存工具类
 */
export class SopUtil {
  // 实例集合
  static instance

  constructor() {
    this.templateList = []
    this.warnDateEnum = []
  }

  static async getInstance() {
    if (!this.instance) {
      const instance = new SopUtil()
      await querySOPConfig({}).then(async(res) => {
        instance.warnDateEnum = res.data.warnDateEnum
        instance.templateList = res.data.templateList
      })
      this.instance = instance
    }
    return this.instance
  }

  /**
   * 获取模板列表
   * @param lob
   */
  getTemplateList(lob) {
    if (!this.templateList) {
      return []
    }
    const templates = this.templateList.filter(item => item.lob === lob)
    return templates || []
  }

  /**
   * 指定岗位-列表显示列转换
   * @param list CommonState数据源
   * @param params
   * @returns {string}
   */
  static notifierRolesLabelFunc(list, params) {
    const ruleItems = params.data.warningRuleItemList
    if (!ruleItems || ruleItems.length === 0) {
      return ''
    }
    const ruleItemArray = []
    for (const ruleItem of ruleItems) {
      ruleItemArray.push(ColumnUtils.constantsNameByMultiNumberValue(list, ruleItem.notifierRoles, ',', true))
    }
    return ruleItemArray.join('\n')
  }

  /**
   * 指定人员-列表显示列转换
   * @param params
   * @returns {string}
   */
  static notifierIdsLabelFunc(params) {
    const ruleItems = params.data.warningRuleItemList
    if (!ruleItems || ruleItems.length === 0) {
      return ''
    }
    const ruleItemArray = []
    for (const ruleItem of ruleItems) {
      ruleItemArray.push(ColumnUtils.getUserDefinedLabel(ruleItem.notifierIds))
    }
    return ruleItemArray.join('\n')
  }

  /**
   * 预警级别-列表显示列转换
   * @param value
   * @returns {string}
   */
  static warningLevelLabelFunc(value) {
    const state = CommonState.getStateByCode(Array.from(SystemConstants.LEVELS), value)
    return CommonState.getName(state)
  }

  /**
   * 预警级别-列表显示列转换
   * @param params
   * @returns {string}
   */
  static warningLevelsLabelFunc(params) {
    const ruleItems = params.data.warningRuleItemList
    if (!ruleItems || ruleItems.length === 0) {
      return ''
    }
    const ruleItemArray = []
    for (const ruleItem of ruleItems) {
      ruleItemArray.push(this.warningLevelLabelFunc(ruleItem.level))
    }
    return ruleItemArray.join('\n')
  }

  /**
   * 预警状态-列表显示列转换
   * @param value
   * @returns {string}
   */
  static warningStateLabelFunc(value) {
    const state = CommonState.getStateByCode(WarnRuleConstants.WARN_STATES, value)
    return CommonState.getName(state)
  }

  /**
   * 预警开启状态-列表显示列转换
   * @param value
   * @returns {string}
   */
  static alertOnStatusLabelFunc(value) {
    return value === 1 ? lang.t('CargoMsg.Cargo_StartAlert') : lang.t('CargoMsg.Cargo_CloseAlert')
  }

  /**
   * 自动忽略方式-列表显示列转换
   * @param value
   * @returns {string}
   */
  static autoIgnoreModeLabelFunc(params) {
    return params.value === 1 ? params.data.ignoreTime + lang.t('CargoMsg.Cargo_AutomaticallyIgnoreAfterHours') : lang.t('CargoMsg.Cargo_TurnOffAutoIgnore')
  }

  /**
   * 预警模式-列表显示列转换
   * @param value
   * @returns {string}
   */
  static earlyWarningModeLabelFunc(value) {
    return value === 1 ? lang.t('CargoMsg.Cargo_SOPNodeOfAlert') : lang.t('CargoMsg.Cargo_DataServiceReminder')
  }

  /**
   * 预警模式-列表显示列转换
   * @param value
   * @returns {string}
   */
  static warningConditionsLabelFunc(list, params) {
    const state = CommonState.getStateByCode(list, params.value)
    const name = CommonState.getName(state)
    if (params.data.type === 2) {
      return name
    }
    const ruleItems = params.data.warningRuleItemList
    if (!ruleItems || ruleItems.length === 0) {
      return name
    }
    const ruleItemArray = []
    for (const ruleItem of ruleItems) {
      const ruleItemName = this.ruleItemLabelFunc(ruleItem.ruleItem)
      const timeName = ruleItem.duration + lang.t('SeaExport.Hour') + ruleItem.minute + lang.t('CargoMsg.Cargo_Cent')
      ruleItemArray.push(ruleItemName + timeName + ';')
    }
    return name + ':' + ruleItemArray.join('\n')
  }

  /**
   * 预警模式-列表显示列转换
   * @param value
   * @returns {string}
   */
  static warningConditionsTimeLabelFunc(list, params) {
    const state = CommonState.getStateByCode(list, params.data.warningDateField)
    const name = CommonState.getName(state)
    return name + ':' + params.data.startTime.substring(0, 10)
  }

  static ruleItemLabelFunc(value) {
    if (value === '1') {
      return lang.t('CargoMsg.Cargo_BringForward')
    }
    if (value === '2') {
      return lang.t('CargoMsg.Cargo_Postpone')
    }
    return ''
  }

  static timeFormat(hour, minute) {
    if (!hour && !minute) {
      return ''
    }
    if (!hour) {
      return minute + lang.t('CargoMsg.Cargo_Cent')
    }
    if (!minute) {
      return hour + lang.t('SeaExport.Hour')
    }
    return hour + lang.t('SeaExport.Hour') + minute + lang.t('CargoMsg.Cargo_Cent')
  }

  static handleCondition(item, condition) {
    const time = this.timeFormat(item.duration, item.minute)
    if (!time) {
      return lang.t('CargoMsg.Cargo_AlreadyHere') + condition
    }
    if (item.ruleItem === '1') {
      // 提前
      return lang.t('CargoMsg.Cargo_AndTo', [time, condition])
    }
    return lang.t('CargoMsg.Cargo_IsOver', [condition, time])
  }

  /**
   * 校验sop模板是否发送变更
   * @param job
   * @param view
   * @param seaEQ
   * @param containerUsages
   * @param templateConfig
   * @returns {Promise<void>}
   */
  static async checkSopTemplate(job, view, seaEQ = null, containerUsages = null, templateConfig = null) {
    if (!job) {
      return
    }
    const jobSopInfo = await this.getJobSopInfo({ ...job, seaEQ, containerUsages })
    const sopTemplateKey = jobSopInfo.templateUuid
    if (!job.uuid) { // 新增时、直接对sop模板赋值
      job.trackingTemplateUuid = sopTemplateKey
      return
    }
    // 非新增时、需要验证是否需要变更sop模板
    const sopTemplateChange = LocalStorageUtils.getConfiguration(job.jobNo + '-sopTemplateChange')
    if (sopTemplateChange) { // 不变更所以不处理
      return
    }
    // 判断sop模板uuid是否一致
    if (job.trackingTemplateUuid === sopTemplateKey) {
      return
    }
    // 业务追踪无数据，也直接变更模板，不提醒
    if (!job.trackingTemplateUuid || !jobSopInfo.hasOldSopNode) {
      job.trackingTemplateUuid = sopTemplateKey
      job.isUpdateSopTemplate = true
      return
    }
    // 当模板自动匹配到新模板时，不显示提示
    if (templateConfig?.hidePromptOnTemplateAutoMatch) {
      job.trackingTemplateUuid = sopTemplateKey
      job.isUpdateSopTemplate = true
      return
    }
    // 不一致时，询问是否需要保留
    await view.$confirm(lang.t('CargoMsg.Cargo_SopTemplateChangeTips', [jobSopInfo.templateName]), lang.t('common.tips.prompt'), {
      confirmButtonText: lang.t('SeaExport.Yes'),
      cancelButtonText: lang.t('SeaExport.No'),
      closeOnClickModal: false,
      showClose: false,
      closeOnPressEscape: false,
      type: 'info'
    }).then(() => {
      // 选是时会记录后续该业务都不更新，针对个人有效
      LocalStorageUtils.setConfiguration(job.jobNo + '-sopTemplateChange', true)
    }).catch(() => {
      // 需要更新
      job.trackingTemplateUuid = sopTemplateKey
      job.isUpdateSopTemplate = true
    })
  }

  static async getJobSopInfo(job) {
    if (job.lob === 'SE') {
      return await getSEJobSopInfo(job).then(res => res.data)
    }
    if (job.lob === 'SI') {
      return await getSIJobSopInfo(job).then(res => res.data)
    }
    if (job.lob === 'AE') {
      return await getAEJobSopInfo(job).then(res => res.data)
    }
    if (job.lob === 'AI') {
      return await getAIJobSopInfo(job).then(res => res.data)
    }
    if (job.lob === 'RE') {
      return await getREJobSopInfo(job).then(res => res.data)
    }
    if (job.lob === 'RI') {
      return await getREJobSopInfo(job).then(res => res.data)
    }
    if (job.lob === 'IE') {
      return await getIEJobSopInfo(job).then(res => res.data)
    }
    return ''
  }

  /**
   * 获取整拼类型
   * @returns {unknown[]|*[]}
   */
  static getFLclType(lob) {
    if (!lob) {
      return []
    }
    if (lob === 'RE' || lob === 'SE' || lob === 'RI') {
      return ContainerLoadType.CONTAINERLOAD_TYPES
    }
    if (lob === 'SI') {
      return ImportConstants._cargoTypeInputList
    }
    if (lob === 'IE') {
      return ContainerLoadType.IE_TYPES
    }
    return Array.from(ChargeUtils.getCargoType(lob))
  }

  /**
   * 获取sop模板列表
   * @param newRows
   * @returns {Promise<{}>}
   */
  static async getSopTemplateMap(newRows) {
    const sopTemplateKeys = Array.from(newRows, p => p.trackingTemplateUuid)
    let sopTemplateMap = {}
    await getTrackingBySopTemplateKeys([...new Set(sopTemplateKeys)].join(',')).then(res => {
      sopTemplateMap = res.data
    })
    return sopTemplateMap
  }

  /**
   * 预警模式-列表显示列转换
   * @param value
   * @returns {string}
   */
  static singleWarningConditionsLabelFunc(list, params) {
    const state = CommonState.getStateByCode(list, params.data.warningDateField)
    const name = CommonState.getName(state)
    if (params.data.warnType === 2) {
      return name
    }
    if (state && state.field === 'TRIGGER_TRACKING_DETAIL_UUID') {
      return params.value
    }
    return this.handleCondition(params.data, name)
  }

  /**
   * 获取指定业务类型的数据项
   * @param lob
   * @returns {[]}
   */
  static sopDataItems(lob) {
    const sopDataItem = [] // 数据项
    return sopDataItem
  }

  /**
   * 获取指定业务类型的数据项
   * @param lob
   * @returns {[]}
   */
  static async getSopColumns(lob) {
    const trackingInfo = await getTrackingInfoByLob(lob)
    const trackingList = trackingInfo.data
    // 动态添加SOP显示列[根据SOP显示列字段进行拆分]
    const columnAdds = []
    if (trackingList && trackingList.length > 0) {
      const headerNameArr = []
      const isZh = $store.getters.language === 'zh'
      // 循环每个节点Sop数据，动态添加显示列
      for (let i = 0; i < trackingList.length; i++) {
        const currentTrack = trackingList[i]
        const columnName = isZh ? currentTrack.codeCname : currentTrack.codeEname
        const columnField = '_sop_' + columnName
        if (!headerNameArr.includes(columnName)) {
          headerNameArr.push(columnName)
          columnAdds.push({
            headerName: columnName,
            colId: columnField,
            field: columnField,
            width: 150,
            hide: true,
            enableRowGroup: true,
            valueGetter: params => {
              return params?.data?.hasOwnProperty(columnField) ? params.data[columnField] : ''
            }
          })
        }
      }
    }
    return columnAdds
  }

  static resolveSopState(results) {
    // 对返回结果进行排序放在后端 getJobsBySort 方法
    // 动态添加SOP显示列[根据SOP显示列字段进行拆分]
    // const headerNameArr = []
    if (results && results.length > 0) {
      for (let i = 0; i < results.length; i++) {
        const job = results[i] // 当前行
        const currentJobSopState = job.sopState // 当前行的SOP数据
        if (!currentJobSopState) continue
        const tracks = currentJobSopState.split(',')
        // console.log('==========tracks===========', tracks)
        // 循环每个节点Sop数据，动态添加显示列
        for (let j = 0; j < tracks.length; j++) {
          const currentTrack = tracks[j]
          if (!currentTrack) continue
          const columnName = currentTrack.split('(')[0]
          const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
          const columnValue = !oldColumnValue ? '' : oldColumnValue
          //
          const columnField = '_sop_' + columnName
          // if (!headerNameArr.includes(columnName)) {
          //   headerNameArr.push(columnName)
          //   this.columnAdds.push({ headerName: columnName, field: columnField, width: 100, hide: true })
          // }
          results[i][columnField] = columnValue
        }
      }
    }
    return results
  }

  // 获取模板名称
  static async getTemplateName(sopTemplateKey) {
    if (!sopTemplateKey) {
      return ''
    }
    const res = await getListByTemplateKey({ sopTemplateKey })
    return res.data ? res.data.templateName : ''
  }
}
